//import NullComponent from "common/components/NullComponent/NullComponent";
import React, {lazy} from "react";

export const importComponent = component => 
lazy(() => 
    import(`../../${component}`)
  );
